export function visibleChipCount(widths, containerWidth, gap, overflowWidth) {
	const chips = widths || [];
	if (!chips.length || containerWidth <= 0) return 0;

	const all = chips.reduce((sum, width, index) => sum + width + (index ? gap : 0), 0);
	if (all <= containerWidth) return chips.length;

	let used = overflowWidth;
	let count = 0;
	for (let index = 0; index < chips.length; index += 1) {
		const next = used + (count > 0 ? gap : 0) + chips[index];
		if (next > containerWidth + 0.5) break;
		used = next;
		count += 1;
	}
	return count;
}
